/**
 * Action for Post maintenance status
 */
export enum getPostMaintenanceStatus {
  POST_MAINTENANCE_STATUS_REQUEST = 'POST_MAINTENANCE_STATUS_REQUEST'
}
